import { render, staticRenderFns } from "./ended.vue?vue&type=template&id=523e62b8&scoped=true"
import script from "./ended.vue?vue&type=script&lang=js"
export * from "./ended.vue?vue&type=script&lang=js"
import style0 from "./ended.vue?vue&type=style&index=0&id=523e62b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523e62b8",
  null
  
)

export default component.exports